(function(){
  function init(scope){
    scope.querySelectorAll('[data-keychain-product]').forEach(function(root){
      if(root.dataset.ready)return;
      root.dataset.ready='true';
      var q=function(selector){return root.querySelector(selector)};
      var stage=q('[data-key-stage]');
      var reduced=window.matchMedia('(prefers-reduced-motion: reduce)');
      var frame=0;
      if(stage){
        stage.addEventListener('pointermove',function(event){
          if(reduced.matches||event.pointerType==='touch')return;
          var rect=stage.getBoundingClientRect();
          var x=Math.max(-1,Math.min(1,(event.clientX-rect.left)/rect.width*2-1));
          var y=Math.max(-1,Math.min(1,(event.clientY-rect.top)/rect.height*2-1));
          cancelAnimationFrame(frame);
          frame=requestAnimationFrame(function(){stage.style.setProperty('--key-ry',x.toFixed(3));stage.style.setProperty('--key-rx',(-y).toFixed(3))});
        });
        stage.addEventListener('pointerleave',function(){stage.style.removeProperty('--key-ry');stage.style.removeProperty('--key-rx')});
      }

      var variantInput=q('[data-key-variant]');
      var mainImage=q('[data-key-main]');
      var selectedLabel=q('[data-key-selected]');
      var swapSequence=0;
      function selectPhrase(){
        var option=variantInput&&variantInput.selectedOptions[0];
        if(!option)return;
        var sequence=++swapSequence;
        var img=new Image();
        img.onload=function(){if(sequence!==swapSequence)return;mainImage.src=option.dataset.src;mainImage.alt='Portachiavi '+option.dataset.name;selectedLabel.textContent=option.dataset.name};
        img.src=option.dataset.src;
        var buy=q('[data-key-buy]');
        buy.disabled=option.dataset.available!=='true';
        buy.textContent=buy.disabled?'Esaurito':'Aggiungi al carrello · '+option.dataset.price;
        q('[data-key-price]').textContent=option.dataset.price;
        if(stage){stage.style.setProperty('--key-accent',option.dataset.accent);stage.style.setProperty('--key-accent-soft',option.dataset.soft)}
      }
      if(variantInput){variantInput.addEventListener('change',selectPhrase);selectPhrase()}

      var quantity=q('input[name="quantity"]');
      function step(delta){if(!quantity)return;var min=Number(quantity.min||1),max=Number(quantity.max||99),next=Math.max(min,Math.min(max,Number(quantity.value||min)+delta));quantity.value=String(next);quantity.dispatchEvent(new Event('change',{bubbles:true}))}
      var minus=q('[data-key-minus]'),plus=q('[data-key-plus]');
      if(minus)minus.addEventListener('click',function(){step(-1)});
      if(plus)plus.addEventListener('click',function(){step(1)});

      root.querySelectorAll('[data-key-to-buy]').forEach(function(link){link.addEventListener('click',function(event){event.preventDefault();q('[data-key-buy]').scrollIntoView({behavior:reduced.matches?'auto':'smooth',block:'center'})})});
      var form=q('form');
      if(form)form.addEventListener('submit',function(event){if(location.hash.indexOf('#preview-')===0){event.preventDefault();q('[data-key-status]').textContent='Anteprima: la frase scelta verrà aggiunta al carrello nella versione Shopify.'}});
    });
  }
  window.CCLKeychainInit=init;
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){init(document)});else init(document);
  document.addEventListener('shopify:section:load',function(event){init(event.target)});
})();
